import { useEffect } from 'react';
import { useSubstate } from 'use-substate';

import { client, useErrorNotifications } from 'core/http';
import { SetCustomers } from 'core/Store/customers/actions';
import { selectCustomers } from 'core/Store/customers/selectors';
import { Customer } from 'core/types/customer';

import { PaginationResponse } from './usePagination';

export default function useCustomerSelectable() {
  const showErrorNotification = useErrorNotifications();
  const [customers, dispatch] = useSubstate(selectCustomers);

  useEffect(() => {
    client()
      .get<PaginationResponse<Customer>>('customers')
      .then(response => response.data)
      .then(response => dispatch(new SetCustomers(response.data)))
      .catch(showErrorNotification);
  }, [dispatch, showErrorNotification]);

  return customers;
}
